module.exports = __webpack_public_path__ + "static/media/logo.a224782e.png";